export default __webpack_public_path__ + "static/media/graphql.0fed447c.png";